import Vue from 'vue'
import App from './App.vue'
import './common/rem'
import router from './router'
import store from './store'
import http from './common/http'
import Loading from '@/components/loading/index.js'
import VueCropper from 'vue-cropper'
import VueScroller from "vue-scroller";
// 导入所有的过滤器变量
import * as filters from "./filters/";
// 导出的是对象，可以直接通过key和value来获得过滤器的名和过滤器的方法
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

Vue.use(VueCropper);
Vue.use(Loading);
Vue.use(VueScroller);

// 调试
// import Vconsole from "vconsole";
// const c = new Vconsole();
// export default c;

Vue.prototype.http = http;

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    if (to.query.AntDevice) {
        sessionStorage.setItem('AntDevice', to.query.AntDevice)
    }
    //获取分享人ID
    if(to.query.rec_user_id){
        sessionStorage.setItem('recUserId', to.query.rec_user_id)
    }
    
    next()
})
router.afterEach((to) => {
    document.documentElement.scrollTop = document.body.scrollTop = 0
    document.querySelector('title').innerHTML = to.name
})

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')
